import { createFileRoute } from "@tanstack/react-router";

import { Videos } from "@/components/itv/pages/Videos";
import { carregarPaginaSimples } from "@/lib/pagina-simples";

const PATH = "/videos/";
const TITLE = "Vídeos sobre Nutrologia e Longevidade | Dr. Thiago Viana";
const DESCRIPTION =
  "Assista a explicações médicas do Dr. Thiago Viana sobre emagrecimento, reposição hormonal, massa muscular, creatina e longevidade de forma direta.";

export const Route = createFileRoute("/videos")({
  loader: () => carregarPaginaSimples(PATH, TITLE, DESCRIPTION),
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  return <Videos />;
}
